import {StripeProductName} from "../../../stripe/models/StripeProductNames";
import {StoreProductDefinition, StoreProductMapping} from "../../common/models/StoreProduct";

export enum TfStoreProduct {
    TRADEFLOOR_PRO = "TRADEFLOOR_PRO"
}

const product: StoreProductDefinition = {
    description: "Live Prices, Strategy Builder and pre-trade vetting only available with TradeFloor Pro",
    trial: 0,
    stripeProducts: [StripeProductName.TRADEFLOOR_PRO],
    coupon: null
};

export const TfProductMappings: StoreProductMapping<TfStoreProduct> = {
    TRADEFLOOR_PRO: product,
};
